import React, { useState, useEffect } from "react";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import {
  calculationTypeOptions,
  statutoryComponentTypeOptions,
} from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import {
  useUpdateSatutoryComponentActiveStatus,
  useDeleteStatutoryComponents,
} from "../../queries/payrollQuries";
import { toast } from "react-toastify";

const StatutoryCard = ({ data, selectedType, onEdit }) => {
  const [isActive, setIsActive] = useState({});
  const [confirmDeleteId, setConfirmDeleteId] = useState(null); // ❗ Added here

  const updateStatusMutation = useUpdateSatutoryComponentActiveStatus();
  const deleteComponent = useDeleteStatutoryComponents();

  const handleDeleteClick = (componentId) => {
    setConfirmDeleteId(componentId);
  };

  const handleConfirmDelete = (componentId) => {
    deleteComponent.mutate(
      { component_id: componentId },
      {
        onSuccess: (res) => {
          toast.success(res?.message || "Component deleted successfully");
          setConfirmDeleteId(null);
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message || "Failed to delete component");
          setConfirmDeleteId(null);
        },
      }
    );
  };


  const handleCancelDelete = () => {
    setConfirmDeleteId(null);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const initialMap = {};
      data.forEach((item) => {
        initialMap[item.component_id] = item.is_active;
      });
      setIsActive(initialMap);
    }
  }, [data]);

  const handleToggle = (componentId, newStatus) => {
    if (typeof newStatus !== "boolean") return;

    setIsActive((prev) => ({ ...prev, [componentId]: newStatus }));

    updateStatusMutation.mutate(
      { component_id: componentId, is_active: newStatus },
      {
        onSuccess: (res) => {
          if (res?.status)
            toast.success(res?.message || "Status updated successfully");
          else toast.error(res?.message || "Failed to update status");
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
          setIsActive((prev) => ({ ...prev, [componentId]: !newStatus }));
        },
      }
    );
  };

  const filteredData =
  selectedType === ""
    ? data
    : data.filter(
        (item) => Number(item.statutory_type) === Number(selectedType)
      );

  return (
    <div className="w-full flex flex-col mx-10 gap-6">
      {filteredData.length === 0 ? (
        <div className="bg-white shadow-md border border-gray-100 rounded-lg w-full p-6 flex justify-center items-center">
          <p className="text-gray-400">No components found for this type.</p>
        </div>
      ) : (
        <div className="w-full flex flex-wrap gap-6">
          {filteredData.map((item, idx) => (
            <div
              key={item.component_id || idx}
              className="bg-white shadow-md border border-gray-100 rounded-lg max-w-[490px] p-6 mt-8"
            >
              <div className="flex items-center justify-between pb-4">
                <p className="text-base font-semibold text-[#1F2937]">
                  {item.component_name}
                </p>

                <div className="flex items-center gap-3">
                  <img
                    src="/images/editicon.svg"
                    alt="edit"
                    className="cursor-pointer w-4 h-4"
                    onClick={() => onEdit(item)}
                  />

             
                  {confirmDeleteId === item.component_id ? (
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-600">Confirm?</span>

                      <button
                        className="text-red-600 text-xs font-semibold"
                        onClick={() => handleConfirmDelete(item.component_id)}
                      >
                        Yes
                      </button>

                      <button
                        className="text-gray-500 text-xs"
                        onClick={handleCancelDelete}
                      >
                        No
                      </button>
                    </div>
                  ) : (
                    <img
                      src="/images/delete-menu-icon.svg"
                      alt="Delete"
                      className="cursor-pointer w-4 h-4"
                      onClick={() => handleDeleteClick(item.component_id)}
                    />
                  )}
                </div>
              </div>

              <div className="flex gap-6">
                <ul className="flex flex-col gap-3 text-sm font-normal text-gray-500">
                  <li>Calculation Type</li>
                  <li>Employee Rate</li>
                  <li>Employer Rate</li>
                  <li>Max Limit</li>
                  <li>Calculation Basis</li>
                  <li>State</li>
                  <li>Status</li>
                </ul>

                <ul className="flex flex-col gap-3 text-sm font-medium text-[#1F2937]">
                  <li>
                    {calculationTypeOptions.find(
                      (opt) =>
                        Number(opt.value) === Number(item.calculation_type)
                    )?.label || "-"}
                  </li>
                  <li>{item.employee_rate || "-"}</li>
                  <li>{item.employer_rate || "-"}</li>
                  <li>{item.max_limit || "-"}</li>
                  <li>{item.calculation_basis || "-"}</li>
                  <li>{item.state_name || "N/A"}</li>

                  <li>
                    <ToggleSwitch
                      checked={isActive[item.component_id]}
                      getToggleState={(newStatus) =>
                        handleToggle(item.component_id, newStatus)
                      }
                      disabled={updateStatusMutation.isLoading}
                    />
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatutoryCard;
